export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            移动吃瓜
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            随时随地，吃瓜不耽误
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                  <i className="ri-smartphone-line"></i>
                  <span className="whitespace-nowrap">移动端适配 · 即开即用</span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  无需下载，手机浏览器直达
                </h3>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                  黑料网站已全面适配移动端，无需安装任何App，手机浏览器打开即可畅享全部功能。
                  公交地铁、午休摸鱼、睡前刷瓜——随时随地追踪吃瓜黑料网站、51黑料网站、
                  91黑料网站及网红黑料网站的最新动态。
                </p>
                <div className="flex flex-wrap items-center gap-4 mt-6 justify-center lg:justify-start">
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="whitespace-nowrap">即开即用</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="whitespace-nowrap">省流量优化</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="whitespace-nowrap">夜间模式</span>
                  </div>
                </div>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                >
                  <i className="ri-qr-scan-line"></i>
                  扫码访问移动版
                </a>
              </div>
              <div className="flex-1 flex justify-center p-6 lg:p-0">
                <div className="w-56 h-[420px] rounded-3xl overflow-hidden border-4 border-background-300 shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20mobile%20app%20screen%20mockup%20with%20dark%20warm%20theme%2C%20abstract%20geometric%20layout%20suggesting%20news%20feed%20and%20social%20content%20cards%2C%20coral%20and%20amber%20accents%2C%20clean%20UI%20design%2C%20no%20text%20or%20logos&width=400&height=800&seq=app-mock-2026&orientation=portrait"
                    alt="黑料网站移动端界面预览"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}